import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import globalHome2 from "../Assets/gia2.jpeg";

function ResetPassword() {
  const navigate = useNavigate();
  const { token } = useParams();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `https://backend-global-1vq9.onrender.com/api/auth/reset-password/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password, confirmPassword }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      setMessage("Password reset successful! Redirecting to login...");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#FFFFFF",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(180deg, #E6F7FD, #FFFFFF)",
          padding: "80px 20px 40px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            color: "#010101",
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "12px",
          }}
        >
          Reset Password
        </h1>
        <p
          style={{
            color: "#6C6C6C",
            fontSize: "1rem",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          Enter your new password below.
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "40px",
          padding: "20px",
          flex: 1,
        }}
      >
        <img
          src={globalHome2}
          alt="illustration"
          style={{
            width: "450px",
            maxWidth: "100%",
            height: "30%",
            borderRadius: "0.5rem",
          }}
        />

        <div
          style={{
            flex: "1 1 350px",
            maxWidth: "400px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            required
            minLength={6}
          />

          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={inputStyle}
            required
            minLength={6}
          />

          {error && (
            <div style={{ color: "red", fontSize: "14px", textAlign: "center" }}>
              {error}
            </div>
          )}

          {message && (
            <div
              style={{
                color: "#00AEEF",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {message}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
              border: "none",
              borderRadius: 8,
              padding: "14px",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              width: "100%",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>

          <p
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "#6C6C6C",
            }}
          >
            Remembered your password?{" "}
            <span
              style={{
                color: "#00AEEF",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => navigate("/login")}
            >
              Sign In
            </span>
          </p>
        </div>
      </form>
    </div>
  );
}

const inputStyle = {
  border: "1px solid #E6E6E6",
  borderRadius: 8,
  padding: "12px 16px",
  background: "#fff",
  fontSize: "14px",
  color: "#6C6C6C",
  outline: "none",
  width: "100%",
};

export default ResetPassword;